import { useCreateStream as baseUseCreateStream } from '@vlabs/api/artemy/client';
import type {
  CreateStreamRequest,
} from '@vlabs/api/artemy/model';
import { toast } from 'react-toastify';

import { buildDefaultStreamAnalytics } from '@vlabs/monokit/entities/sources';

import { useCreateStreamTranslation } from '../i18n';
import type { CreateStreamFormValues, CreateStreamProps } from '../types';

interface UseCreateStreamProps extends CreateStreamProps {
  onSuccess?: VoidFunction;
}

export function useCreateStream({
  onCreateStream = undefined,
  onSuccess = undefined,
}: UseCreateStreamProps = {}): {
    onSubmit: (data: CreateStreamFormValues) => Promise<void>;
    isPending: boolean;
  } {
  const { t } = useCreateStreamTranslation();
  const createStream = baseUseCreateStream();

  async function onSubmit(data: CreateStreamFormValues): Promise<void> {
    if (!data.group_id) return;

    const request: CreateStreamRequest = {
      name: data.name,
      data: {
        type: data.type,
        reference: data.reference,
      },
      group_id: data.group_id,
      // Наследуемые ВА приходят от группы — шлём только добавленные пользователем.
      // Пустой массив не отправляем: бэк отклоняет analytics: []
      // (axios-клиент вычищает undefined-ключи из тела)
      analytics: data.analytics.length > 0
        ? data.analytics.map((item) => buildDefaultStreamAnalytics(
          item.type,
          item.label,
          item.handlerId,
        ))
        : undefined,
    };

    try {
      const { stream_id: streamId } = await createStream.mutateAsync({ data: request });

      onSuccess?.();
      toast.success(t('on_success'));
      onCreateStream?.(streamId);
    } catch {
      toast.error(t('on_error'));
    }
  }

  return {
    onSubmit,
    isPending: createStream.isPending,
  };
}
